import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-projectrequest',
  templateUrl: './list-projectrequest.component.html',
  styleUrls: ['./list-projectrequest.component.css']
})
export class ListProjectrequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/sitesupervisor/list-projectrequest/list-projectrequest.component.ts